/**
 * Responsive Elements Handler
 *
 * This module removes DOM elements that are not needed for the current viewport
 * to prevent duplicate functionality and improve performance.
 */

class ResponsiveElements {
  constructor() {
    this.desktopMediaQuery = window.matchMedia("(min-width: 1024px)");

    // Initial setup
    this.setupElements();

    // Listen for viewport changes
    this.desktopMediaQuery.addEventListener("change", () =>
      this.setupElements(),
    );
  }

  setupElements() {
    const isDesktop = this.desktopMediaQuery.matches;

    // Remove desktop-only elements on mobile
    document.querySelectorAll("[data-desktop-only]").forEach((element) => {
      if (!isDesktop) {
        element.remove();
      }
    });

    // Remove mobile-only elements on desktop
    document.querySelectorAll("[data-mobile-only]").forEach((element) => {
      if (isDesktop) {
        element.remove();
      }
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new ResponsiveElements();
  });
} else {
  new ResponsiveElements();
}

export { ResponsiveElements };
